import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { Tab } from 'app/interfaces/tab.interface';

@Component({
  selector: 'app-page-dashboard',
  templateUrl: './page-dashboard.component.html',
  styleUrls: ['./page-dashboard.component.scss'],
  imports: [MatTabsModule, MatIconModule, RouterLinkActive, RouterLink, RouterOutlet, TranslocoModule],
})
export class PageDashboardComponent {
  dashboardTabs: Tab[] = [
    {
      label: `TAB_DASHBOARD_SUMMARY`,
      path: `summary`,
      icon: 'dashboard_2',
    },
    {
      label: `TAB_DASHBOARD_MAP`,
      path: `map`,
      icon: 'map',
    },
  ];
}
